import { render, staticRenderFns } from "./NumberPresent.vue?vue&type=template&id=4450a401&scoped=true"
import script from "./NumberPresent.vue?vue&type=script&lang=js"
export * from "./NumberPresent.vue?vue&type=script&lang=js"
import style0 from "./NumberPresent.vue?vue&type=style&index=0&id=4450a401&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450a401",
  null
  
)

export default component.exports